import React, { useCallback, useState } from 'react';
import { AutoComplete } from 'antd';
import FormItem from './FormItem';
import NotEditableItem from './NotEditableItem';

export default function FormAutocomplete({ editable, name, value, error, onChange, layout, label, required, getData, ...props }) {
  const [options, setOptions] = useState([]);
  const onSearch = useCallback((filter) => {
    getAndPrepareData(filter);
  });

  if (!editable) {
    return (
      <NotEditableItem title={props.placeholder} value={value} />
    );
  }

  return (
    <FormItem
      label={label}
      required={required}
      error={error}
      layout={layout}
    >
      <AutoComplete
        style={{ width: 200 }}
        name={name}
        value={value}
        onChange={onChange}
        onSearch={onSearch}
        defaultValue=""
        {...props}
      >
        {options}
      </AutoComplete>
    </FormItem>
  );

  async function getAndPrepareData(filter) {
    const data = await getData(filter);

    setOptions(prepareOptions(data));
  }
}

function prepareOptions(data) {
  if (!Array.isArray(data)) {
    throw new Error('Wrong data for Select options');
  }

  return data.map(({ name, ...props }) => (
    <AutoComplete.Option key={name} {...props}>{name}</AutoComplete.Option>
  ));
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/Autocomplete.js